export default __webpack_public_path__ + "static/media/githubMurad.a9d26cb4.png";